/**
 * @generated SignedSource<<bd011c282d48ca47ee4954e578466294>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaElementPopover_program$data = {
  readonly id: string;
  readonly " $fragmentType": "MediaElementPopover_program";
};
export type MediaElementPopover_program$key = {
  readonly " $data"?: MediaElementPopover_program$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaElementPopover_program">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaElementPopover_program",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Program",
  "abstractKey": null
};

(node as any).hash = "aa99a072c44f33ca7151f93a4c855d77";

export default node;
